import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import ConsoleLogger from "../Utils/ConsoleLogger";
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import { Map, GoogleApiWrapper, Polyline, withGoogleMap, Marker, InfoWindow, Paper, Typography } from 'google-maps-react';



let config = require('../Config/appConfig.json');
let api_credentials_url = config.GET_API_CREDENTIALS;
const context = "Map.js";
const mapStyles = {
    width: '100%',
    height: '100%'
};
@inject("appStore")
@observer
class CustomMap extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lng: 0,
            showingInfoWindow: true,
            activeMarker: {},
            selectedPlace: {}
        };
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.onMapClick = this.onMapClick.bind(this);
    }

    componentWillMount = () => {

    }

    onMarkerClick = (props, marker, e) => {
        console.log("Marker => ", marker)
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    }

    onMapClick = (props) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    }

    generateMarkers = () => {
       var abc =  (
            <div>
                <Marker
                    onClick={this.onMarkerClick}
                    title={'Changing Colors Garage'}
                    position={{ lat: 22.5726, lng: 88.3639 }}
                    name={'Changing Colors Garage'}
                >
                    <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                    >
                        <div>
                            asdadada
                        </div>
                    </InfoWindow>
                </Marker>
                <Marker
                    onClick={this.onMarkerClick}
                    title={'Changing Colors Garage'}
                    position={{ lat: 22.26, lng: 88.39 }}
                    name={'Changing Colors Garage'}
                >
                    <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                    >
                        <div>
                            asdadada
                        </div>
                    </InfoWindow>
                </Marker>
            </div>
        );

        return abc;
    }


    componentDidMount = () => {
        //console.log("PROPS", this.props);
    }
    render() {

        var lat = 22.5726, lng = 88.3639;
        var marker = null
        if (this.props.PathCoordinates != "") {
            lat = Number(this.props.PathCoordinates[0]['lat']);
            lng = Number(this.props.PathCoordinates[0]['lng']);

            console.log("lat=" + lat + " lng=" + lng)
            marker = this.generateMarkers()
            console.log("Markerssss => ", marker)
        }

        var initial_lat = this.props.lat;
        var initial_lng = this.props.lng;

        console.log("initial_lat=" + initial_lat + " initial_lng=" + initial_lng)
        // this.generateCenterLatLong(initial_lat,initial_lng)
        var bounds = new this.props.google.maps.LatLngBounds();
        for (var i = 0; i < this.props.PathCoordinates.length; i++) {
            bounds.extend(this.props.PathCoordinates[i]);
        }

        return (
            <div>
                <Map google={this.props.google}
                    style={{ width: '90%', height: '90%', position: 'relative' }}
                    className={'map'}
                    initialCenter={{
                        lat: 22.5791,
                        lng: 88.4694
                    }}  
                    bounds={bounds}
                    zoom={14}>
                    <Polyline
                        path={this.props.PathCoordinates}
                        strokeColor="#6b6e6f"
                        strokeOpacity={0.8}
                        strokeWeight={6}
                        geodesic={true}
                        //onGoogleApiLoaded={({map, maps}) => this.renderMarkers(map, maps)}
                        options={{
                            strokeColor: "#6b6e6f",
                            strokeOpacity: 1,
                            strokeWeight: 3
                        }}
                    />
                    {marker}

                </Map>
            </div >
        );
    }
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyD-7FX7CHe-Qk6dz1tnMKcDM-wuejSfXhU',
    v: "3.30"
})(CustomMap);


// WEBPACK FOOTER //
// ./src/Pages/CustomMap.js